import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import { useLocale } from '../contexts/LocaleContext';
import { useOnboarding } from '../contexts/OnboardingContext';
import { OnboardingBubbleContent } from './OnboardingBubbleContent';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

export const OnboardingMobileBubble: React.FC = () => {
  const isMobile = useIsMobile();
  const { t } = useLocale();
  const { mobileBubbleOpen, setMobileBubbleOpen, progress } = useOnboarding();

  if (!isMobile) {
    return null;
  }

  return (
    <Dialog open={mobileBubbleOpen} onOpenChange={setMobileBubbleOpen}>
      <DialogContent className="max-w-[min(100vw-2rem,24rem)]">
        <DialogHeader className="sr-only">
          <DialogTitle>{t('onboarding_title')}</DialogTitle>
          <DialogDescription>{t('onboarding_title')}</DialogDescription>
        </DialogHeader>
        {progress ? (
          <OnboardingBubbleContent progress={progress} />
        ) : (
          <p className="text-xs text-muted-foreground">{t('loading')}</p>
        )}
      </DialogContent>
    </Dialog>
  );
};
